<script lang="ts">
  import { regionStore } from "$lib/stores/region";

  const regionInfo = regionStore();

  const region = $regionInfo.region;
</script>

<svelte:head>
  {#if region === "eu"}
    <script
      type="text/javascript"
      src="https://try.abtasty.com/d74ea99550226ceb226f092988871a86.js"
    ></script>
  {:else if region === "us"}
    <script
      type="text/javascript"
      src="https://try.abtasty.com/cf29c35aa05ce09218c8eee36aa41b3a.js"
    ></script>
  {:else if region === "de"}
    <script
      type="text/javascript"
      src="https://try.abtasty.com/02f5caf9019ffeb4a3f98e5ad052a228.js"
    ></script>
  {:else if region === "uk"}
    <script
      type="text/javascript"
      src="https://try.abtasty.com/1eec34d7417aecac3a69b8392b51ab48.js"
    ></script>
  {:else if region === "row"}
    <script
      type="text/javascript"
      src="https://try.abtasty.com/481976c4e3b356e9a8be3c7b293fd70b.js"
    ></script>
  {/if}
</svelte:head>
